import { dummyId } from '@/utils/chat';
import { memo } from 'react';

const stableDummyIdCache = new Map();

export const processMessage = (item) => {
  const temp = Array.isArray(item)
    ? item.filter((m) => m.selected === true)
    : [item];

  const every =
    (Array.isArray(item) && item.every((e) => e._id)) || !Array.isArray(item);
  const realItem = temp.length && every ? temp[0] : null;

  let realKey;
  if (realItem?._id) {
    realKey = realItem._id;
  } else {
    // Create a stable cache key based on message content and timestamp
    const cacheKey =
      !Array.isArray(item) && item.data?.role === 'user'
        ? `user-${item.date}-${item.data?.content?.slice(0, 50)}`
        : `item-${JSON.stringify(item).slice(0, 100)}`;

    // Use cached dummy ID if exists, otherwise generate and cache new one
    if (stableDummyIdCache.has(cacheKey)) {
      realKey = stableDummyIdCache.get(cacheKey);
    } else {
      realKey = dummyId();
      stableDummyIdCache.set(cacheKey, realKey);
    }
  }

  const isUserMessage = !Array.isArray(item) && item.data?.role === 'user';

  return { realItem, realKey, isUserMessage };
};

export const clearStableDummyIdCache = () => {
  stableDummyIdCache.clear();
};

export const ReferenceDiv = memo(
  ({ index, isUserMessage, item, realKey, messageRefs }) => (
    <div
      key={index}
      ref={(el) => {
        if (el) {
          if (isUserMessage) {
            messageRefs.current.byDate[item.date] = el;
          } else {
            messageRefs.current.byId[realKey] = el;
          }
        }
      }}
    />
  )
);
